<template>
	<div class="landing-title-extended">
		<h1 v-html="title" class="landing-title-extended__title" data-typo-type="title" />
		<h2 v-if="subtitle" class="landing-title-extended__subtitle" data-typo-type="subtitle">
			{{ subtitle }}
		</h2>
		<h3 v-if="note" class="landing-title-extended__note" data-typo-type="note">
			{{ note }}
		</h3>
	</div>
</template>

<script>
export default {
	name: 'LandingTitleExtended',
	props: {
		title: {
			type: String,
			required: true,
		},

		subtitle: {
			type: String,
			default: '',
		},

		note: {
			type: String,
			default: null,
		},
	},
}
</script>

<style lang="scss" scoped>
.landing-title-extended {
	text-align: center;
	margin-bottom: var(--size-16);

	&__title {
		font-size: var(--size-30);
		line-height: var(--size-36);
		text-transform: uppercase;
		font-weight: 700;
		margin: 0;
	}

	&__subtitle {
		font-size: var(--size-20);
		line-height: var(--size-28);
		text-transform: uppercase;
		font-weight: 600;
		margin: 0;
	}

	&__note {
		margin-top: var(--size-12);
		margin-bottom: 0;

		font-size: var(--size-18);
		line-height: var(--size-22);
		font-weight: 500;

		color: var(--Text-Primary-60);
	}
}
</style>
